// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import React, { useMemo } from 'react';
import { useLocalize } from '@ta/platform.i18n';
import SearchResult from './SearchResult';
import { type TypeaheadItem } from './types';
import { type SearchResultsPlaceholderQuery_insightProfile_locations as Location } from './SearchResultsPlaceholderQuery.gql';
import getImageSources from './getImageSources';
import styles from './RecentLocations.css';

type Props = {
  locations: $ReadOnlyArray<?Location>,

  maxResults?: number,

  /** Callback for when a result is clicked */
  onResultClicked?: TypeaheadItem => mixed,
};

/**
 * Displays recently viewed locations. This is shown if there is currently no query but the
 * typeahead is open.
 */
const RecentLocations = ({ locations, maxResults = 5, onResultClicked }: Props) => {
  const { localize } = useLocalize();

  const results: TypeaheadItem[] = useMemo(() => {
    const resultList = [];

    locations.forEach(entry => {
      if (
        resultList.length < maxResults &&
        entry != null &&
        entry.location != null &&
        entry.location.url != null &&
        entry.location.locationId != null &&
        entry.location.locationId > 1
      ) {
        const { name, additionalNames, thumbnail, url, locationId } = entry.location;

        resultList.push({
          title: name || '',
          subtitle:
            entry.location.parentId === 1
              ? null
              : additionalNames?.stateAndCountryOrEquivalent || null,
          image: getImageSources(thumbnail),
          url,
          details: { type: 'LOCATION', locationId },
          key: String(locationId),
        });
      }
    });

    return resultList;
  }, [locations, maxResults]);

  if (results.length === 0) {
    return null;
  }

  return (
    <>
      {/* RECENTLY VIEWED */}
      <div className={styles.header}>{localize('dual_search_recently_viewed_all_caps')}</div>

      {results.map(result => (
        <SearchResult key={result.key} result={result} selected={false} onClick={onResultClicked} />
      ))}
    </>
  );
};

export default RecentLocations;
